import { ViewModelPropertyChangedEventArgsInterface } from "@nts/std/interfaces";

export class ViewModelPropertyChangedEventArgs implements ViewModelPropertyChangedEventArgsInterface  {
    propertyName: string;
}
